module.exports = __webpack_public_path__ + "static/media/img-come-funziona-0-18.f9c479a8.png";